<template>
    <div
        class="w-6 centre-absolute aspect-square before:rounded-full before:block before:w-full before:h-full before:border-4 before:border-brand1 before:border-solid before:border-t-transparent before:border-r-transparent before:border-b-white before:border-l-white before:animate-spin"
    ></div>
</template>
